import type { ReactNode } from 'react'
import './figure-list.css'

/**
 * Figures read down a card: what each is on the leading edge, the figure on
 * the trailing one in the numeric face, a hairline between rows. A row with
 * nothing to say is left out by the caller rather than shown as zero.
 */
export function FigureList({
  rows,
}: {
  rows: readonly {
    /** Names the row where two can share a label — two pledges for one item. */
    id?: string
    label: string
    value: ReactNode
    note?: ReactNode
  }[]
}) {
  if (rows.length === 0) return null
  return (
    <dl className="figure-list">
      {rows.map((row) => (
        <div key={row.id ?? row.label} className="figure-list__row">
          <dt className="figure-list__label">
            {row.label}
            {row.note ? (
              <span className="figure-list__note">{row.note}</span>
            ) : null}
          </dt>
          <dd className="figure-list__value">{row.value}</dd>
        </div>
      ))}
    </dl>
  )
}
